import axiosLogin from "@/api/axiosLogin"

import * as Sentry from "@sentry/vue";

const state = {
    isLogin: sessionStorage.getItem('isLogin') ? sessionStorage.getItem('isLogin') : false,
    username: sessionStorage.getItem('username') ? sessionStorage.getItem('username') : '游客',
    userId: sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '',
    // 存储token
    Authorization: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
    requestNum:0, //登录请求次数，用来让用户重新输入登录信息

    homeSelectMenu:sessionStorage.getItem('homeSelectMenu') ? sessionStorage.getItem('homeSelectMenu') : '', //首页选择的案例

    replayInterval:null
}

const getters = {
    getRequestNum:state=>state.requestNum
}

const actions = {
    //注册
    register({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'POST',
                url:'/auth_center/register',
                data:{
                    "username": data.username,
                    "password": data.password,
                    "company": data.company,
                    "phone": data.phone,
                    "email": data.email,
                    "email_code": data.emailCode,
                    "purpose": data.purpose,
                    "research": data.research
                }
            })
            .then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //发送邮箱验证码，type=1：注册验证码，=2：改密码验证码
    sendEmailCode({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'POST',
                url:'/auth_center/code',
                data:{
                    "ctype": data.type,
                    "email": data.email
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //验证码校验
    validEmailCode({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'POST',
                url:'/auth_center/check_code',
                data:{
                    "email": data.email,
                    "email_code": data.emailCode
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //检查用户名是否被注册
    checkUsername({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'GET',
                url:'/auth_center/check_username?username=' + data.username
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //检查邮箱是否被使用
    checkEmail({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'GET',
                url:'/auth_center/check_email?email=' + data.email
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改密码
    modifyPassword({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'POST',
                url:'/auth_center/change_password',
                data:{
                    "email": data.email,
                    "email_code": data.emailCode,
                    "password": data.newPassword
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //登录
    login({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'POST',
                url:'/auth_center/login',
                data:{
                    "username": data.username,
                    "password": data.password
                }
            }).then(res=>{
                if(process.env.NODE_ENV === 'production'){
                    let replay = Sentry.getReplay();
                    replay.startBuffering();
                    Sentry.setUser({
                        'username': data.username,
                        'ip_address': window.location.host
                    })
                    
                    commit('setReplay', replay);
                }

                if(res.data.code != 200){
                    commit('project/setProjectList', [], {root:true});
                    commit('setUserToken','');
                    commit('setUsername', '');
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                    commit('setIsLogin', false);
                    sessionStorage.removeItem('username');
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('isLogin');
                    sessionStorage.removeItem('userAvatar');
                    sessionStorage.removeItem('homeSelectMenu');
                    sessionStorage.removeItem('selectProject');
                    sessionStorage.removeItem('tabPage');
                    sessionStorage.removeItem('homeSelectMenu');
                    sessionStorage.removeItem('selectGroup');
                }
                else{
                    commit('setUserToken',res.data.data.token);
                    commit('setUsername',res.data.data.username);
                    commit('setUserId', res.data.data.userid);
                    commit('setIsLogin', true);
                    sessionStorage.setItem('isLogin', true);
                    sessionStorage.setItem('username', res.data.data.username);
                    sessionStorage.setItem('userId', res.data.data.userid);
                    sessionStorage.setItem('token', 'Bearer ' + res.data.data.token);

                    dispatch('user/getUserInfo', {}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //退出
    logout({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosLogin({
                method:'GET',
                url:'/auth_center/logout',
                headers:{
                    Authorization: data.token
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    if(process.env.NODE_ENV === 'production'){
                        let replay = Sentry.getReplay();
                        replay.stop();
                    }

                    commit('setIsLogin', false);
                    commit('setUserToken', '');
                    commit('setUsername', '');
                    commit('setUserId', '');
                    commit('project/setProjectList', [], {root:true});
                    commit('user/setUserAvatar', '', {root:true});
                    sessionStorage.removeItem('username');
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('isLogin');
                    sessionStorage.removeItem('userAvatar');
                    sessionStorage.removeItem('homeSelectMenu');
                    sessionStorage.removeItem('selectProject');
                    sessionStorage.removeItem('tabPage');
                    sessionStorage.removeItem('selectProject');
                    sessionStorage.removeItem('selectGroup');
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    }
}

const mutations = {
    setUserToken(state, token){
        state.Authorization = 'Bearer ' + token;
    },
    setUsername(state, username){
        state.username = username;
    },
    setUserId(state, userId){
        state.userId = userId;
    },
    setIsLogin(state, isLogin){
        state.isLogin = isLogin;
        state.requestNum += 1;
    },
    setHomeSelectMenu(state, selectMenu){
        state.homeSelectMenu = selectMenu;
        sessionStorage.setItem('homeSelectMenu', selectMenu);
    },
    setReplay(state, replay){
        if(state.replayInterval == null && replay._replay._isEnabled){
            state.replayInterval = setInterval(() => {
                Sentry.flush().then(res=>{
                    replay.stop().then(res=>{
                        replay.start();
                    });
                });
            }, 60 * 60 * 1000);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}